<template>
	<section class="ap-header">
		<div class="ap-actions ap-actions--left">
			<button type="button" class="theme_btn_dark" @click="uploadAllPlanAccounts">
				Importar
			</button>
			<a class="download_btn" :href="`${hostname}/xlsx/${templateName}.xlsx`">
				<component :is="'DownloadFile'"></component>
				<span class="ml-1">Descargar Plantilla</span>
			</a>
			<input type="file" ref="fileInput" @change="(e) => uploadFilePlanAccounts(e)" accept=".xlsx,.xls"
				style="display: none" />
		</div>
		<h2 class="ap-title">Plan de Cuentas</h2>
		<div class="ap-actions ap-actions--right">
			<button v-if="hasRepeatedPlanAccount" type="button" class="theme_btn_red"
				@click="$emit('make-unique')">
				Hacer único
			</button>
			<button type="button" class="theme_btn_white" @click="$emit('export-accounts')">
				Exportar
			</button>
			<button v-if="needsReview" type="button" class="theme_btn_blue"
				@click="$emit('approve-review')">
				Completado
			</button>
		</div>
	</section>
</template>

<script>
import DownloadFile from "@/components/svg/DownloadFile.vue";

export default {
	name: "AccountPlanHeader",
	components: {
		DownloadFile,
	},
	props: {
		templateName: {
			type: String,
			default: "",
		},
		hasRepeatedPlanAccount: {
			type: Boolean,
			default: false,
		},
		needsReview: {
			type: Boolean,
			default: false,
		},
	},
	computed: {
		hostname() {
			const publicPath = window.location.hostname
			const localhost = ["localhost", "0.0.0.0"]
			if (localhost.includes(window.location.hostname)) {
				return `http://${publicPath}`;
			} else {
				return `https://${publicPath}`;
			}
		},
	},
	methods: {
		uploadAllPlanAccounts() {
			this.$refs.fileInput.click();
		},
		uploadFilePlanAccounts(e) {
			const file = e.target.files[0];
			e.target.value = null;
			if (!file) return;
			this.$emit("file-selected", file);
		},
	},
};
</script>
<style scoped lang="scss">
@use "./account_plan_buttons" as *;

.ap-header {
	position: relative;
	display: flex;
	align-items: center;
	justify-content: center;
	min-height: 44px;
	margin-bottom: 1.25rem;
}

.ap-title {
	font-size: 1.2rem;
	font-weight: 700;
	color: var(--ap-ink);
	text-align: center;
}

.ap-actions {
	position: absolute;
	top: 50%;
	transform: translateY(-50%);
	display: flex;
	align-items: center;
	gap: 0.5rem;

	&--left {
		left: 0;
	}

	&--right {
		right: 0;
	}
}

.download_btn {
	display: inline-flex;
	align-items: center;
	gap: 0.25rem;
	max-width: fit-content;
	padding: 8px 14px;
	border: 1px solid var(--ap-line-strong);
	border-radius: var(--ap-radius-sm);
	background: var(--ap-paper);
	color: var(--ap-ink-2);
	font-family: var(--ap-font);
	font-size: 14px;
	font-weight: 600;
	line-height: 20px;
	text-decoration: none;
	transition: color 0.18s var(--ap-ease), border-color 0.18s var(--ap-ease);

	&:hover {
		color: var(--ap-teal);
		border-color: var(--ap-teal);
	}

	&:focus-visible {
		outline: 2px solid var(--ap-teal);
		outline-offset: 2px;
	}
}
</style>
